// extracted by mini-css-extract-plugin
export default {"cell":"SimpleTableCell_cell__eQ245"};